import React, { FC } from 'react';
import { Form } from 'tea-component';
import { ISingleTextProps } from '../../type';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '../../utils';


const SingleText: FC<ISingleTextProps> = (props) => {
  const { formItem } = props;
  const { formatMessage } = useIntlExtend();
  
  return (
	  <Form.Text>{getShowLabel(formItem, formatMessage)}</Form.Text>
  );
};

export default SingleText;